// utils/format.js
export const formatTiming = (timing) => {
  switch (timing) {
    case "FULL_DAY":
      return "Full Day";
    case "FIRST_HALF":
      return "First Half";
    case "SECOND_HALF":
      return "Second Half";
    default:
      return timing; // fallback
  }
};

export function formatDate(dateString) {
  if (!dateString) return "";

  // Expecting input in "YYYY-MM-DD"
  const [year, month, day] = dateString.split("-");
  return `${day}-${month}-${year}`;
}





